import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./About.module.css";

/* Reutilizamos o mesmo padrão de ícones do ValueProps */
function Icon({ name }) {
  const common = {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
  };

  switch (name) {
    case "science":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F2F6FF" />
          <g transform="translate(6,6)">
            <circle cx="18" cy="10" r="6" fill="#6B46FF" />
            <rect x="6" y="22" width="24" height="6" rx="3" fill="#00B894" />
          </g>
        </svg>
      );
    case "temperament":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#FFF9F6" />
          <g transform="translate(6,6)">
            <ellipse cx="12" cy="20" rx="6" ry="6" fill="#FF7A59" />
            <ellipse cx="26" cy="12" rx="5" ry="5" fill="#FFBFAA" />
          </g>
        </svg>
      );
    case "character":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F6FFF8" />
          <g transform="translate(6,6)">
            <rect x="6" y="8" width="20" height="6" rx="3" fill="#00B894" />
            <rect x="6" y="18" width="14" height="6" rx="3" fill="#6B46FF" />
          </g>
        </svg>
      );
    case "practice":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F7FBFF" />
          <g transform="translate(6,6)">
            <path
              d="M6 22c6-8 16-8 22-2"
              fill="none"
              stroke="#6B46FF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <circle cx="6" cy="22" r="3" fill="#6B46FF" />
          </g>
        </svg>
      );
    default:
      return null;
  }
}

export default function About() {
  const { t } = useTranslation("home");

  const blocks = [
    {
      icon: "science",
      title: t("about.scienceTitle"),
      text: t("about.scienceText"),
    },
    {
      icon: "temperament",
      title: t("about.temperamentTitle"),
      text: t("about.temperamentText"),
    },
    {
      icon: "character",
      title: t("about.characterTitle"),
      text: t("about.characterText"),
    },
    {
      icon: "practice",
      title: t("about.practiceTitle"),
      text: t("about.practiceText"),
    },
    // {
    //   icon: "practice",
    //   title: "Da compreensão à prática diária",
    //   text: "O objetivo do Ibhava não é apenas gerar insight, mas apoiar mudanças reais. Por isso, o relatório se conecta ao Ibhava Daily, um aplicativo focado na prática cotidiana, onde planos, exercícios e hábitos ganham forma no dia a dia.",
    // },
  ];

  return (
    <section className={styles.root} aria-labelledby="about-title">
      <div className={styles.container}>
        <h2 id="about-title">{t("about.title")}</h2>

        <p className={styles.subtitle}>{t("about.subtitle")}</p>

        <div className={styles.grid}>
          {blocks.map((block, index) => (
            <article key={index} className={styles.card}>
              <div className={styles.iconWrap}>
                <Icon name={block.icon} />
              </div>
              <div className={styles.cardBody}>
                <h3>{block.title}</h3>
                <p>{block.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
